import React, { useState, useEffect, useRef } from "react";
import enableTableSearch from "../utility/table";
import ExportCSV from "./ExportCSV";
import API_BASE_URL from "../config";

function SubjectTable({ reload }) {
  const [subjects, setSubjects] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();

  useEffect(() => {
    fetch(API_BASE_URL + "/api/subject")
      .then((res) => res.json())
      .then((data) => setSubjects(data.subjects))
      .catch((err) => console.error("Error fetching subject:", err));
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No subject found",
    });

    return cleanup;
  }, []);

  return (
    <div id="table-container">
      <div id="header">
        <p>Subject List</p>
      </div>
      <hr />
      <div id="table-actions">
        <ExportCSV
          entries={subjects.map((item, index) => [item.type])}
          header={["TYPE"]}
        />
        <div className="search-box">
          <label>Search:</label>
          <input type="text" id="search" name="search" ref={inputRef} />
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>SUBJECT</th>
          </tr>
        </thead>
        <tbody id="table-body" ref={tableRef}>
          {subjects.map((item, index) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.subject}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SubjectTable;
